export const Constants = {
    /**
    * Endereço padrão do servidor
    */
    URL: "https://piracema-json-server.vercel.app/",
    // URL: "http://localhost:3000/",

    /**
    * Quantidade de peixes carregados por padrão
    */
    PEIXES: 5,

    /**
    * Texto exibido quando nenhum registro é mostrado em uma listagem
    */
    LISTAGEM: "Nenhum Registro Encontrado..."
};